import { render } from "./LoaderComponent.vue?vue&type=template&id=8658e3ac&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=8658e3ac&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8658e3ac"]])

export default __exports__